import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileActionBar from "@/components/MobileActionBar";
import RossiAssistant from "@/components/RossiAssistant";
import WhatsAppButton from "@/components/WhatsAppButton";

export const Layout = () => {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <main className="pt-16 pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileActionBar />
      <WhatsAppButton />
      <RossiAssistant />
    </div>
  );
};

export default Layout;
